import React from 'react';
import AccountGroupManagementCard from '../components/AccountGroupManagementCard';

export default function AccountGroupManagementScreen() {
  return <><AccountGroupManagementCard /></>
}
